import React, { useEffect, useState, useRef } from "react";
import { CallService, modalAlert } from "../../Js/Script";
import DataGrid from "../../Js/Grid";
//img
import excel from "../../Resources/Images/excel.svg";
import print from "../../Resources/Images/print.svg";
import Login from "../Login";

const Organization = () => {
    const [stData, setStData] = useState({});
    useEffect(() => {
        CallService("Organization", null, "GET", false, false).then((res) => {
            setStData((prev) => ({ ...prev, organization: res.organization }))
        }).catch((err) => {
            modalAlert(err.message, "خطا");
        });
    }, []);
    useEffect(() => {
        if (stData && stData['organization']) {
            var fieldMapping = {
                organizationId:'#',
                title:'عنوان',
                Opration:'عملیات',
            };
            var organization = stData['organization'].map((organization) => {
                var dvOpration = document.createElement("div"),
                    dvDelete = document.createElement("div"),
                    dvEdit = document.createElement("div"),
                    dvTitle = document.createElement("div"),
                    dvOrganizationId = document.createElement("div"),
                    dvChangeStatus = document.createElement("div");

                var OrganizationIdVar = `<div data-organizationId=${organization.organizationId} style="color:#337ab7;cursor: pointer;">${organization.organizationId}</div>`.toElements()[0];
                var TitleVar = `<div data-organizationId=${organization.organizationId} data-title=${organization.title}></p> ${organization.title}</div>`.toElements()[0];
                var oprationVar = `<div data-ticketId=${organization.organizationId}>
                                        <button id="delete" data-ticketId=${organization.organizationId}>حذف</button>
                                        <button id="edit" data-ticketId=${organization.organizationId}>ویرایش</button>
                                        <button id="changeStatus" data-ticketId=${organization.organizationId}>فعال</button>
                                    </div>`.toElements()[0];

          

                [TitleVar, OrganizationIdVar, oprationVar ].forEach(dv => {
                    dv.addEventListener('click', (e) => {
                        var dataOrganizationId = e.currentTarget.getAttribute("data-organizationId"),
                        dataTitle = e.currentTarget.getAttribute("data-title");
                        //navigateToTicketDetails(dataOrganizationId, dataTitle);
                        //document.querySelector("#delete").addEventListener('click', (e) => {
                        //    console.log("delete", e.target.getAttribute("data-ticketid"))
                        //})
                        //document.querySelector("#edit").addEventListener('click', (e) => {
                        //    console.log("edit", e.target.getAttribute("data-ticketid"))
                        //})
                        //document.querySelector("#changeStatus").addEventListener('click', (e) => {
                        //    console.log("changeStatus", e.target.getAttribute("data-ticketid"))
                        //})
                    })
                })
                dvTitle.appendChild(TitleVar);
                dvOrganizationId.appendChild(OrganizationIdVar);
                dvOpration.appendChild(oprationVar);

                organization.title = dvTitle;
                organization.organizationId = dvOrganizationId;
                organization.Opration = dvOpration;


                return organization;
   
            })
            var grid = new DataGrid(
                organization,
                fieldMapping,
                {
                    selectable: false,
                    order: false,
                },
                {
                    gridAlternateRow: "#F2F2F2",
                },
                (tr) => { }
            ).appendTable(inputRefs.listOfOrganization.current);
        
        }
    }, [stData && stData['organization']]);
    const inputRefs = {
        listOfOrganization: useRef(null),
    };
    return (
        <div>
            <div id="dvOrganization-heading" className="flexRow">
                <div> دپارتمان ها</div>
                <div id="dvOrganization-items" className="primary">

                    <img src={excel}></img>
                    <img src={print}></img>
                </div>
            </div>
            <div id="listOfOrganization" ref={inputRefs.listOfOrganization}></div>
        </div>
    );
};
export default Organization;
